import React, {Component} from 'react';
import { withRouter } from "react-router-dom";




class UserManagement extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>User Management </h2>

                <br/>
               

                <h6> Update User Information </h6>
                
                <p className='text-primary'>Click 'users' in the navigation menu along the top.   
                Enter the user's email addresss. </p>
                <br/><br/><br/>
                <p className='text-primary'>2) Locate the user in the list to edit</p>
                <div className="text-center">
                <img className='text-center' style={{maxWidth:800, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png'  alt=''/> 
              
                   
                </div>

                <br/>
               <hr/>
               <div className="text-center">
                    <img className='text-center' style={{maxWidth:800, width:"100%",maxHeight:800, height:"100%"}} src='./images/UserManagement.png' alt=''/> 
                </div>
                
                <p className='text-primary'>3) Add/Update the first name, last name and phone number of the user</p>

                 <p className='text-primary'>4) Active Status:  This field can only be changed by the hotels administrator.  If the administator is not longer available
                 or needs to be assigned to another user, send an email to support@bounte.net with the ewquest for change.  The admin can't be activated.</p>

                <br/>

               


                 <br/> 
              

                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(UserManagement);
